import { render, staticRenderFns } from "./ccForm.vue?vue&type=template&id=6068c947"
import script from "./ccForm.vue?vue&type=script&lang=js"
export * from "./ccForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports